(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-custom"] && !Shopify.designMode) return;
  try {
    
(function() {

  function initHero() {
    // Heroセクションは1つ前提なので class で拾う
    const root = document.querySelector('section.hero-custom-section');
    if (!root) return;

    const targets = root.querySelectorAll('[data-animate]');
    if (!('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    targets.forEach((t) => io.observe(t));
  }

  document.addEventListener('DOMContentLoaded', initHero);
  document.addEventListener('shopify:section:load', initHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-band-overlap"] && !Shopify.designMode) return;
  try {
    
/* JS不要。テーマの IntersectionObserver を使用（フォールバックは内蔵） */

  } catch(e) { console.error(e); }
})();
})();
